

export enum TransientReservationLinkAction {
  LINK_AND_DO_NOT_PAY_VIA_GP = <any>'LINK_AND_DO_NOT_PAY_VIA_GP',
  LINK_AND_PAY_VIA_GP = <any>'LINK_AND_PAY_VIA_GP'
}

export namespace TransientReservationLinkAction {
  export function getValue(key: string) {
    return TransientReservationLinkAction[key];
  }

  export function fromString(value: string): TransientReservationLinkAction | undefined {
    return (TransientReservationLinkAction as any)[value];
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-table/TransientReservationLinkAction.ts